import Collection from '@/store/models/collections/Collection'
import { trackPublicView, trackPublicTeaser, trackClickout } from '@/api/analytics'

/**
 * Fire-and-forget analytics beacons for the in-app (private) surfaces. The server is
 * the authority — it drops the collection owner's own events, gates non-public
 * collections to their members, and dedups per identity per 30 minutes. The owner
 * check here only avoids firing a request for every interaction with your own
 * library; when the collection isn't in the store the beacon is sent anyway and the
 * server decides.
 */
const isForeignCollection = (collectionId, userId) => {
  const ownerId = Collection.find(collectionId)?.ownerId
  return !ownerId || ownerId !== userId
}

export function beaconCollectionView(collectionId, userId) {
  if (!collectionId || !isForeignCollection(collectionId, userId)) return
  trackPublicView({ collectionId }).catch(() => {})
}

// Item detail view — only items living in a collection have stats
export function beaconItemView(item, userId) {
  if (!item?.isCollectionItem || !isForeignCollection(item.ownerId, userId)) return
  trackPublicView({ collectionId: item.ownerId, itemId: item.id }).catch(() => {})
}

// Click on a bookmark's source link (notes have no destination)
export function beaconClickout(item, userId) {
  if (!item?.isCollectionItem || !item.url || !isForeignCollection(item.ownerId, userId)) return
  trackClickout({ collectionId: item.ownerId, itemId: item.id }).catch(() => {})
}

// Teaser impression: { collectionId } for a collection card, { collectionId, itemId } for an item card
export function beaconTeaser(body, userId) {
  if (!body?.collectionId || !isForeignCollection(body.collectionId, userId)) return
  trackPublicTeaser(body).catch(() => {})
}
